import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import { compose } from "recompose";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";

const getUserTitle = (record, translate) =>
  `${translate("user.label")} ${record.id} (${record.username})`;

const Edit = (props) => {
  const id = props.id?.toString(); // ID della risorsa
  useManageOpenEditTabs(props.resource, id);

  return (
    <RaEdit
      {...props}
      undoable={false}
      title={<DynamicTitleWithTooltip getTitle={getUserTitle} />}
    >
      <Form />
    </RaEdit>
  );
};
export default compose()(Edit);
